import React from 'react';
import { UiComponents } from "@simulanisindia/ui";

const { SkeltonResourceManage } = UiComponents;

const ResourceManagementSkelton = ({ length = 0, width = "50px", height = "50px", circle = true }) => {
    return (
        <>
            <SkeltonResourceManage count={length} width={width} height={height} circle={circle} />
        </>
    )
}

export default ResourceManagementSkelton;
